module.exports = __webpack_public_path__ + "static/media/99.ba98dd92.jpg";